module.exports = __webpack_public_path__ + "static/media/2_pl.aa191a1c.png";